import { ResourceOptions } from 'react-admin';
import { MdOutlineDashboard } from 'react-icons/md';

import { Resources } from '../../resource';

// §14.2 Dashboard (XBIT-4246) at `/vault/dashboard`; the console's `/vault` redirects here (see VaultRootRedirect).
export { default as list } from './Dashboard';
export { DASHBOARD_PERMISSION_RESOURCE } from './constants';

export const name = Resources.vaultDashboard;
export const icon = MdOutlineDashboard;
export const options: ResourceOptions = {
  label: 'module.vaultDashboard.title',
};
